import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import BasicAuth from "./app/auth/BasicAuth";
import { ProtectedRoute } from "./app/ProtectedRoute/ProtectedRoute";
import ChoiceSubdivisions from "./components/choice/ChoiseSubdivisions";
import Dashboard from "./components/dashboard/Dashboard";
import Loading from "./components/loading/Loading";
import { hasAccess } from "./features/auth/newAuth";
import { getAllIcons } from "./features/implementers/ImplemetnersSlice";

function App() {

    const { implementers } = useSelector((state) => state.implementers.subdivisions);

    const [loading, setLoading] = useState(true)
    const { access } = useSelector(state => state.auth)
    const dispatch = useDispatch()

    useEffect(() => {
        async function fetchData() {
            await Promise.all([
                dispatch(hasAccess()),
                dispatch(getAllIcons())
            ])
            setLoading(false)
        }
        fetchData()
    }, [dispatch])

    if (loading) return <Loading />

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <ProtectedRoute canUseRouteIf={!!access} ifNotAllowedPath="/login">
                        {implementers?.length ? <Dashboard implementers={implementers} /> : <ChoiceSubdivisions />}
                    </ProtectedRoute>
                }
            />
            <Route path="/login" element={<BasicAuth />} />
        </Routes>
    );
}

export default App;
